"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalTags = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Subtitle_atom_1 = require("../atoms/Subtitle.atom");
const Styled = styled_components_1.default.div `
	ul {
		margin: 0;
		padding: 0;
	}

	li {
		list-style-type: none;
		display: inline-block;
	}

	.subTitle {
		margin-bottom: 4px;
		text-align: center;
		.footer-text {
			font-size: 8px;
			color: ${(p) => p.theme.palette.accent.text};
		}
	}

	img {
		background-size: contain;
		max-height: 120px;
	}

	${(p) => p.theme.breakpoints.down("sm")} {
		text-align: center;
	}
`;
const LegalTags = ({ legalTags = [] }) => {
    if (!legalTags || !legalTags.length)
        return null;
    return (react_1.default.createElement(Styled, null,
        react_1.default.createElement("ul", { className: "tags" }, legalTags.map((tag) => {
            return (react_1.default.createElement("li", { key: `legaltag-${tag.title}` },
                react_1.default.createElement(Subtitle_atom_1.Subtitle, { subTitle: tag.title }),
                react_1.default.createElement("img", { alt: "legal", src: tag.src })));
        }))));
};
exports.LegalTags = LegalTags;
//# sourceMappingURL=LegalTags.molecule.js.map